var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicktokFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_54206",
    "data-name": "Group 54206",
    transform: "translate(0 0.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_103090",
    "data-name": "Path 103090",
    transform: "translate(0 -0.204)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,0A21,21,0,1,1,0,21,21,21,0,0,1,21,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21 3 C 16.19202995300293 3 11.67182922363281 4.872329711914062 8.272079467773438 8.272079467773438 C 4.872329711914062 11.67182922363281 3 16.19202995300293 3 21 C 3 25.80797004699707 4.872329711914062 30.32817077636719 8.272079467773438 33.72792053222656 C 11.67182922363281 37.12767028808594 16.19202995300293 39 21 39 C 25.80797004699707 39 30.32817077636719 37.12767028808594 33.72792053222656 33.72792053222656 C 37.12767028808594 30.32817077636719 39 25.80797004699707 39 21 C 39 16.19202995300293 37.12767028808594 11.67182922363281 33.72792053222656 8.272079467773438 C 30.32817077636719 4.872329711914062 25.80797004699707 3 21 3 M 21 0 C 32.59798049926758 0 42 9.402019500732422 42 21 C 42 32.59798049926758 32.59798049926758 42 21 42 C 9.402019500732422 42 0 32.59798049926758 0 21 C 0 9.402019500732422 9.402019500732422 0 21 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-tiktok",
    "data-name": "Icon simple-tiktok",
    d: "M13.1.02C14.389,0,15.664.01,16.938,0a6.107,6.107,0,0,0,1.716,4.088,6.914,6.914,0,0,0,4.157,1.755V9.794a10.494,10.494,0,0,1-4.118-.951A12.113,12.113,0,0,1,17.1,7.931c-.01,2.863.01,5.725-.02,8.578a7.488,7.488,0,0,1-1.324,3.863,7.3,7.3,0,0,1-5.794,3.147,7.149,7.149,0,0,1-4-1.01,7.393,7.393,0,0,1-3.578-5.6c-.02-.49-.029-.98-.01-1.461A7.381,7.381,0,0,1,10.938,8.9c.02,1.451-.039,2.9-.039,4.353A3.364,3.364,0,0,0,6.6,15.333a3.889,3.889,0,0,0-.137,1.578A3.337,3.337,0,0,0,9.9,19.725a3.294,3.294,0,0,0,2.716-1.578,2.262,2.262,0,0,0,.4-1.039c.1-1.755.059-3.5.069-5.255.01-3.951-.01-7.892.02-11.833Z",
    transform: "translate(8.466 9.031)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicktokFooter);
export default __webpack_public_path__ + "static/media/TicktokFooter.7ac01263828d4667f233fd2ab755d416.svg";
export { ForwardRef as ReactComponent };